import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import { useLang } from "../i18n";
import { Header } from "../components/Header";
import { CheckCircle2, Copy } from "lucide-react";
import { toast } from "sonner";

export default function Confirmation() {
  const { state } = useLocation();
  const { t } = useLang();

  if (!state?.code_anonyme) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-card rounded-2xl shadow-sm border border-slate-200/80 p-8 sm:p-10 text-center animate-fade-up" data-testid="confirmation-card">
          <span className="grid place-items-center w-16 h-16 rounded-full bg-emerald-100 text-emerald-600 mx-auto">
            <CheckCircle2 className="w-9 h-9" />
          </span>
          <h1 className="mt-6 font-display text-2xl sm:text-3xl font-extrabold text-slate-900">{t("conf.title")}</h1>
          <p className="mt-3 text-slate-600 leading-relaxed">{t("conf.desc")}</p>

          <div className="mt-8 rounded-xl bg-primary/5 border border-primary/20 p-6">
            <p className="text-xs font-semibold uppercase tracking-wider text-primary">{t("conf.code")}</p>
            <div className="mt-2 flex items-center justify-center gap-3">
              <span className="font-display text-3xl font-extrabold text-primary tracking-wide" data-testid="confirmation-code">
                {state.code_anonyme}
              </span>
              <button
                data-testid="copy-code-btn"
                onClick={() => { navigator.clipboard.writeText(state.code_anonyme); toast.success("Copié / Copied"); }}
                className="text-slate-400 hover:text-primary transition-colors"
              >
                <Copy className="w-5 h-5" />
              </button>
            </div>
            <p className="mt-2 text-xs text-slate-500">{t("conf.keep")}</p>
          </div>

          {state.date_soumission && (
            <p className="mt-4 text-sm text-slate-500">
              {t("conf.date")}: <span className="font-semibold text-slate-700">{state.date_soumission}</span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
